import React from 'react';
import '../styles/Update.css';

function Update() {
  return (
    <div className="app">
      <header className="header">
        <h1>ஈரோடு புத்தகத் திருவிழா - 2025</h1>
        <h2>Erode Book Festival - 2025</h2>
        <p className="subtitle">
          தமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனைப் பேரவை இணைந்து நடத்தும் 21 ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா
        </p>
        <p className="date">அரங்க ஒதுக்கீடு குலுக்கல் நிகழ்வு: 21.07.2025</p>
      </header>

      <div className="content">
        <div className="announcement">
          <p>
            ஈரோடு புத்தகத் திருவிழாவில் அரங்குகள் அமைக்கும் நிறுவனங்கள் மற்றும் குலுக்கலின் மூலம் தேர்வு செய்யப்பட்ட அரங்க எண்கள் அடங்கிய பட்டியல்
          </p>
        </div>

        <div className="stall-lists">
          <StallList 
            title="Single Stall List" 
            data={singleStallData} 
          />
          <StallList 
            title="Double Stall List" 
            data={doubleStallData} 
            isDouble={true}
          />
        </div>
      </div>

      {/* <footer className="footer">
        <p>© 2025 Erode Book Festival. All rights reserved.</p>
      </footer> */}
    </div>
  );
}

const StallList = ({ title, data, isDouble = false }) => {
  return (
    <div className={`stall-list ${isDouble ? 'double' : ''}`}>
      <h3>{title}</h3>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Stall Number{isDouble ? 's' : ''}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.sno}</td>
                <td>{item.name}</td>
                <td>{item.stallNumber}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Single stall data
const singleStallData = [
  { sno: 1, name: 'AAMU PUBLICATIONS', stallNumber: '182' },
  { sno: 2, name: 'AGASTHIAR PUBLICATIONS', stallNumber: '97' },
  { sno: 3, name: 'ANANDHA NILAYAM', stallNumber: '81' },
  { sno: 4, name: 'ANNAM PUBLISHERS', stallNumber: '34' },
  { sno: 5, name: 'ARAM PATHIPPAGAM', stallNumber: '96' },
  { sno: 6, name: 'ARUN PATHIPPAGAM', stallNumber: '106' },
  { sno: 7, name: 'ARUTCHELVAR Dr. N. MAHALINGAM TRANSLATION INSTITUTE', stallNumber: '155' },
  { sno: 8, name: 'AZHVARGAL AIVU MAIYAM', stallNumber: '43' },
  { sno: 9, name: 'B. RATHNA NAYAKAR & SONS', stallNumber: '117' },
  { sno: 10, name: 'ERODE PADAIPPALARGAL', stallNumber: '147' },
  { sno: 11, name: 'EUREKA BOOKS', stallNumber: '183' },
  { sno: 12, name: 'EXPRESS PUBLICATIONS ( DINAMANI )', stallNumber: '38' },
  { sno: 13, name: 'GANGAAAAANI PATHIPPAGAM', stallNumber: '48' },
  { sno: 14, name: 'GAURANGA BOOK DISTRIBUTORS', stallNumber: '122' },
  { sno: 15, name: 'GEETHAM PUBLICATIONS', stallNumber: '140' },
  { sno: 16, name: 'GIRI LAW HOUSE', stallNumber: '105' },
  { sno: 17, name: 'GIRI TRADING AGENCY PVT.LTD', stallNumber: '107' },
  { sno: 18, name: 'GOWRA PUTHAKA MAIYAM', stallNumber: '30' },
  { sno: 19, name: 'HARISH BOOKS', stallNumber: '45' },
  { sno: 20, name: 'HINDU TAMIL THISAI', stallNumber: '208' },
  { sno: 21, name: 'INTERNATIONAL INSTITUTE OF TAMIL STUDIES', stallNumber: '12' },
  { sno: 22, name: 'ISLAMIC FOUNDATION TRUST', stallNumber: '166' },
  { sno: 23, name: 'IYALVAAGAI', stallNumber: '124' },
  { sno: 24, name: 'JEEVA PATHIPPAGAM', stallNumber: '154' },
  { sno: 25, name: 'KRISHNAMURTHI FOUNDATION INDIA', stallNumber: '188' },
  { sno: 26, name: 'KUMARAN PATHIPPAGAM', stallNumber: '153' },
  { sno: 27, name: 'LKM PUBLICATION', stallNumber: '25' },
  { sno: 28, name: 'MASK', stallNumber: '31' },
  { sno: 29, name: 'BASIC BOOK HOUSE', stallNumber: '42' },
  { sno: 30, name: 'MUTHU COMICS', stallNumber: '26' },
  { sno: 31, name: 'NAM PUBLICATION', stallNumber: '215' },
  { sno: 32, name: 'NAN NOOL VELIYITAGAM', stallNumber: '1' },
  { sno: 33, name: 'NANMOZHI PATHIPAGAM', stallNumber: '53' },
  { sno: 34, name: 'NATARAJ PUBLICATIONS', stallNumber: '59' },
  { sno: 35, name: 'NIVETHITHA PATHIPPAGAM', stallNumber: '29' },
  { sno: 36, name: 'PALANIAPPA BROTHERS', stallNumber: '98' },
  { sno: 37, name: 'PANMAI VELI', stallNumber: '146' },
  { sno: 38, name: 'PARISAL PUTTHAGA NILAYAM', stallNumber: '4' },
  { sno: 39, name: 'PUDHUPUNAL', stallNumber: '86' },
  { sno: 40, name: 'PURE CINEMA BOOK SHOP', stallNumber: '13' },
  { sno: 41, name: 'PUTHAGAKADAI.COM', stallNumber: '14' },
  { sno: 42, name: 'RAJATHI PATHIPPAGAM', stallNumber: '78' },
  { sno: 43, name: 'RAJMOHAN PATHIPPAGAM', stallNumber: '20' },
  { sno: 44, name: 'SATHYAA ENTERPRISES', stallNumber: '87' },
  { sno: 45, name: 'SHANTI BOOKS', stallNumber: '123' },
  { sno: 46, name: 'SIVAGURU PATHIPPAGAM', stallNumber: '58' },
  { sno: 47, name: 'SMILE PUBLISHING INDIA PVT.LTD', stallNumber: '17' },
  { sno: 48, name: 'SREE INDHU PUBLICATIONS', stallNumber: '94' },
  { sno: 49, name: 'SRI PUTHAKA KALANJIYAM', stallNumber: '152' },
  { sno: 50, name: 'SRI UNIVERSAL BOOK HOUSE', stallNumber: '110' },
  { sno: 51, name: 'SRI VIVEKANANDA SEVALAYAM', stallNumber: '95' },
  { sno: 52, name: 'STEPHEN BOOK SELLER', stallNumber: '41' },
  { sno: 53, name: 'TAMIL UNIVERSITY', stallNumber: '60' },
  { sno: 54, name: 'TAMIZHINI', stallNumber: '156' },
  { sno: 55, name: 'THAMARAI BROTHERS MEDIA PVT. LTD', stallNumber: '157' },
  { sno: 56, name: 'THAMIZH CHOLAI PATHIPPAGAM', stallNumber: '201' },
  { sno: 57, name: 'THE ALLIANCE COMPANY', stallNumber: '93' },
  { sno: 58, name: 'THUMBI TANNARAM NULVELI', stallNumber: '173' },
  { sno: 59, name: 'TICK SOFT', stallNumber: '141' },
  { sno: 60, name: 'UYIRMAI PATHIPPAGAM', stallNumber: '125' },
  { sno: 61, name: 'VAGAM COMICS', stallNumber: '44' },
  { sno: 62, name: 'VAIGARAI PATHIPPAGAM', stallNumber: '220' },
  { sno: 63, name: 'VAMSI BOOKS', stallNumber: '90' },
  { sno: 64, name: 'VANATHI PATHIPPAGAM', stallNumber: '35' },
  { sno: 65, name: 'VANAVIL PUTHAKALAYAM', stallNumber: '84' },
  { sno: 66, name: 'VETHATHIRI PUBLICATIONS', stallNumber: '75' },
  { sno: 67, name: 'VIDIYAL PATHIPPAGAM', stallNumber: '118' },
  { sno: 68, name: 'YAAVARUM PUBLISHERS', stallNumber: '85' }
];

// Double stall data
const doubleStallData = [
  { sno: 1, name: 'A.M.BOOK HOUSE', stallNumber: '202 , 203' },
  { sno: 2, name: 'AAKAR BOOKS', stallNumber: '05 , 06' },
  { sno: 3, name: 'AMAR CHITRAKATHA PVT LTD', stallNumber: '184 , 185' },
  { sno: 4, name: 'ANA BOOKS', stallNumber: '49 , 50' },
  { sno: 5, name: 'ANANDA VIKATAN PUBLISHERS PVT LTD', stallNumber: '99 , 100' },
  { sno: 6, name: 'APPLE PUBLISHING INTERNATIONAL (P) LTD', stallNumber: '103 , 104' },
  { sno: 7, name: 'ARIVU PATHIPPAGAM', stallNumber: '36 , 37' },
  { sno: 8, name: 'AROCKIYA BOOKS', stallNumber: '144 , 145' },
  { sno: 9, name: 'ARUNA PUBLICATIONS', stallNumber: '39 , 40' },
  { sno: 10, name: 'BOOK WORLD', stallNumber: '186 , 187' },
  { sno: 11, name: 'CORAL PUBLISHERS & DISTRIBUTORS', stallNumber: '221 , 222' },
  { sno: 12, name: 'DISCOVERY BOOK PALACE', stallNumber: '126 , 127' },
  { sno: 13, name: 'DREAM WAYS', stallNumber: '113 , 114' },
  { sno: 14, name: 'DREAMLAND PUBLICATIONS', stallNumber: '56 , 57' },
  { sno: 15, name: 'EDU BOOK DISTRIBUTORS', stallNumber: '211 , 212' },
  { sno: 16, name: 'EDUPRO INC', stallNumber: '142 , 143' },
  { sno: 17, name: 'ESWAR BOOK CENTER', stallNumber: '27 , 28' },
  { sno: 18, name: 'ETHIR VELIYEDU', stallNumber: '213 , 214' },
  { sno: 19, name: 'FROZEN BOOKS', stallNumber: '46 , 47' },
  { sno: 20, name: 'GOWTHAM PATHIPPAGAM', stallNumber: '150 , 151' },
  { sno: 21, name: 'HIGGINBOTHAMS ( P ) LTD', stallNumber: '218 , 219' },
  { sno: 22, name: 'JAINCO PUBLISHERS', stallNumber: '76 , 77' },
  { sno: 23, name: 'KANNADHASAN PATHIPPAGAM', stallNumber: '134 , 135' },
  { sno: 24, name: 'KANNAPPAN PATHIPPAGAM', stallNumber: '193 , 194' },
  { sno: 25, name: 'KARPAGAM PUTHAKALAYAM', stallNumber: '136 , 137' },
  { sno: 26, name: 'KIZHAKKU PATHIPPAGAM', stallNumber: '132 , 133' },
  { sno: 27, name: 'LEO BOOK DISTRIBUTORS', stallNumber: '158 , 159' },
  { sno: 28, name: 'LOTUS MULTIMEDIA', stallNumber: '160 , 161' },
  { sno: 29, name: 'M.M. BOOK DISTRIBUTER', stallNumber: '23 ,24' },
  { sno: 30, name: 'MADHUMITHA BOOKS', stallNumber: '164 , 165' },
  { sno: 31, name: 'MANIVASAGAR PATHIPPAGAM', stallNumber: '130 , 131' },
  { sno: 32, name: 'MARUTHUVA PATHIPPAGAM', stallNumber: '209 , 210' },
  { sno: 33, name: 'MAYILAVAN PATHIPPAGAM', stallNumber: '71 , 72' },
  { sno: 34, name: 'MEENAKSHI BOOK SHOP', stallNumber: '2 , 3' },
  { sno: 35, name: 'MONAJ PUBLICATION', stallNumber: '178 , 179' },
  { sno: 36, name: 'MOTHERLAND BOOK HOUSE', stallNumber: '174 , 175' },
  { sno: 37, name: 'NAKKHEERAN', stallNumber: '18 , 19' },
  { sno: 38, name: 'NARMADHA PATHIPPAGAM', stallNumber: '21 , 22' },
  { sno: 39, name: 'NATIONAL BOOK TRUST', stallNumber: '111 , 112' },
  { sno: 40, name: 'NATRINAI PATHIPPAGAM', stallNumber: '128 , 129' },
  { sno: 41, name: 'OM SAKTHI BOOKS INTERNATIONAL', stallNumber: '115 , 116' },
  { sno: 42, name: 'OMNI BOOKS', stallNumber: '167 , 168' },
  { sno: 43, name: 'PARRAGON PUBLISHING PVT LTD', stallNumber: '54 , 55' },
  { sno: 44, name: 'PENGUIN RANDOM HOUSE INDIA', stallNumber: '10 , 11' },
  { sno: 45, name: 'PRAKASH BOOKS INDIA PVT.LTD', stallNumber: '197 , 198' },
  { sno: 46, name: 'PUBLICATIONS DIVISION GOVT.OF.INDIA', stallNumber: '64 , 65' },
  { sno: 47, name: 'PUSTAKA DIGITAL MEDIA PVT. LTD', stallNumber: '66 , 67' },
  { sno: 48, name: 'SAHITYA AKADEMI', stallNumber: '108 , 109' },
  { sno: 49, name: 'SAKTHI PUBLISHING HOUSE', stallNumber: '176 , 177' },
  { sno: 50, name: 'SAPNA BOOK HOUSE PVT. LTD', stallNumber: '191 , 192' },
  { sno: 51, name: 'SCHOLASTIC INDIA PVT LTD', stallNumber: '15 , 16' },
  { sno: 52, name: 'SHANKAR PATHIPPAGAM', stallNumber: '169 , 170' },
  { sno: 53, name: 'SHREE BALAJI BOOK SELLER & DISTRIBUTORS', stallNumber: '79 , 80' },
  { sno: 54, name: 'SIXTHSENSE PUBLICATIONS', stallNumber: '180 , 181' },
  { sno: 55, name: 'SPIDER BOOKS', stallNumber: '91 , 92' },
  { sno: 56, name: 'SRI BHARATHI PUBLICATIONS', stallNumber: '138 , 139' },
  { sno: 57, name: 'SRI RAMAKRISHNA MATH', stallNumber: '206 , 207' },
  { sno: 58, name: 'SRIRAM BOOKS', stallNumber: '73 , 74' },
  { sno: 59, name: 'SUCCESS BOOK SELLERS', stallNumber: '32 , 33' },
  { sno: 60, name: 'TAMIL DESAM PUTHAGA ANGADI', stallNumber: '101 , 102' },
  { sno: 61, name: 'TAMILNADU PAADA NOOL KALAGAM', stallNumber: '204 , 205' },
  { sno: 62, name: 'THE PERIYAR SELF RESPECT PROPAGANDA INSTUTION', stallNumber: '171 , 172' },
  { sno: 63, name: 'THIRUMAGAL NILAYAM', stallNumber: '51 , 52' },
  { sno: 64, name: 'TIGER BOOKS PYT LTD', stallNumber: '216 , 217' },
  { sno: 65, name: 'UNIVERSAL PUBLISHERS', stallNumber: '195 , 196' },
  { sno: 66, name: 'UPKAR PRAKASHAN', stallNumber: '82 , 83' },
  { sno: 67, name: 'V.O.C. NOOLAGAM', stallNumber: '199 , 200' },
  { sno: 68, name: 'VALLALAR BOOK SHOP', stallNumber: '189 , 190' },
  { sno: 69, name: 'VALLI PATHIPAGAM', stallNumber: '88 , 89' },
  { sno: 70, name: 'WISDOM GLOBAL SERVICE', stallNumber: '148 , 149' },
  { sno: 71, name: 'ZERO DEGREE PUBLISHING', stallNumber: '162 , 163' }
];

export default Update;